const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case 'table.timesheet_report/SET_TABLE_PARAMS':
            return {
                ...state,
                ...action.params,
            };
        case 'table.timesheet_report/LIST_TIMESHEETS_SUCCESS':
            return {
                ...state,
                data: action.response.data,
                additional_params: action.response.additional_params,
                ...action.response.pagination,
            };
        case 'table.timesheet_report/LIST_TIMESHEETS_FILTERS_SUCCESS':
            return {
                ...state,
                filters: action.response.filters,
            };
        default:
            return state;
    }
}
